import {put, takeLatest, call} from 'redux-saga/effects';
import * as tableService from "../../../services/tableService.js";

import {
    UPDATE_TABLE,
    UPDATE_TABLE_SUCCESS,
    UPDATE_TABLE_ERROR,
}
    from "../../actions/table";

function* updateTableSaga(action) {
    try {
        const data =  yield call(tableService.UpdateTable, action.payload)
        yield put({
            type: UPDATE_TABLE_SUCCESS,
            payload: data
        });
      


    } catch (error) {
        yield put({
            type: UPDATE_TABLE_ERROR,error: error.data
        });
    }
}


export function* updateTableSagaWatcher() {
    yield takeLatest(UPDATE_TABLE, updateTableSaga);
}